import React from 'react';
import { Group, Text, useMantineTheme, rem } from '@mantine/core';
import { Dropzone, IMAGE_MIME_TYPE, DropzoneProps, FileRejection } from '@mantine/dropzone';
import { IconPhoto, IconUpload, IconX } from '@tabler/icons-react';

interface ImageDropzoneProps extends Partial<DropzoneProps> {
  instruction: string;
  onDrop: (files: File[]) => void;
  onReject: (files: FileRejection[]) => void;
}

const ImageDropzone: React.FC<ImageDropzoneProps> = ({
  onDrop,
  onReject,
  instruction,
  ...props
}) => {
  const theme = useMantineTheme();

  return (
    <Dropzone
      onDrop={onDrop}
      onReject={onReject}
      accept={IMAGE_MIME_TYPE}
      maxFiles={1}
      sx={{ flexGrow: 2 }}
      {...props}
    >
      <Group
        position="center"
        spacing="xl"
        style={{ minHeight: rem(120), pointerEvents: 'none' }}
      >
        <Dropzone.Accept>
          <IconUpload
            size="3.2rem"
            color={theme.colors[theme.primaryColor][theme.colorScheme === 'dark' ? 4 : 6]}
          />
        </Dropzone.Accept>

        <Dropzone.Reject>
          <IconX
            size="3.2rem"
            color={theme.colors.red[theme.colorScheme === 'dark' ? 4 : 6]}
          />
        </Dropzone.Reject>

        <Dropzone.Idle>
          <IconPhoto size="3.2rem"/>
        </Dropzone.Idle>

        <div>
          <Text size="xl" inline>
            Arrastra cualquier imagen aquí
          </Text>
          <Text size="sm" color="dimmed" inline mt={7}>
            {instruction}
          </Text>
        </div>
      </Group>
    </Dropzone>
  );
};

export default ImageDropzone;
